const dynamicFreeShipping = function () {
  let total = 0;
  const cartItems = Array.from(document.querySelectorAll('.drawer__cart-items-wrapper .cart-item'));
  const freeShippingMessageEls = Array.from(
    document.querySelectorAll('.free-shipping-message'),
  );

  cartItems.forEach((item) => {
    const price = +item.getAttribute('data-price');
    const quantity = +item.querySelector('.quantity__input').getAttribute('value');
    total += price * quantity;
  });
  let threshold = +window.freeShippingThreshold
  if (isNaN(threshold)) {
    threshold = 0
  }

  document.addEventListener('cart:quantity:changed', (e) => {
    const { name, line } = e.detail;
    const productLine = (
      document.querySelector(`#CartDrawer-Item-${line}`)
      || document.querySelector(`#CartItem-${line}`)
    );
    if (!productLine) return;
    const productPrice = +productLine.getAttribute('data-price');

    if (name == 'plus') {
      total += productPrice;
    } else if (name == 'minus') {
      total -= productPrice;
    }
    freeShippingMessageEls.forEach((el) => {
      if (total >= threshold) {
        el.textContent = 'You are eligible for free shipping!';
      } else {
        el.textContent = `Spend $${((threshold - total) / 100).toFixed(2)} more and get free shipping!`;
      }
    });
  });
};

export default dynamicFreeShipping;
